import { format } from 'date-fns/fp';

export const timestampToDay = (timestamp: number): string => {
  return format('dd/MM')(new Date(timestamp));
};
